import React from 'react';
import AppraiserAppraisalsTable from './AppraiserAppraisalsTable';
import AppraiserAppraisalsDataMapper from '../../../mappers/AppraiserAppraisalsDataMapper';

/**
 * @typedef {object} AppraiserAppraisalsTabTablesProps
 * @property {Array<*>} [searchedAppraisals]
 * @property {Array<*>} [assignedAppraisals]
 * @property {Array<*>} [autoAssignedAppraisals]
 * @property {(event: React.MouseEvent, id: number) => void} [handleAssignClick]
 * @property {(event: React.MouseEvent, id: number) => void} [handleOpenConfirmDialog]
 * @property {(offset: number) => void} [handlePageChange]
 * @property {number} [searchedAppraisalsCount]
 * @property {number} [pageSize]
 * @property {number} [searchCurrentPage]
 * @property {string} [activeTab]
 * @property {boolean} [loading]
 */

/**
 * @param {AppraiserAppraisalsTabTablesProps} props
 */
const AppraiserAppraisalsTabTables = props => {
  const {
    activeTab,
    handlePageChange,
    searchCurrentPage,
    searchedAppraisals = [],
    assignedAppraisals = [],
    autoAssignedAppraisals = [],
    searchedAppraisalsCount = 0,
    pageSize = 10,
    ...otherProps
  } = props;

  const isSearchMode = activeTab === TABLE_MODE.search;
  const isManualMode = activeTab === TABLE_MODE.manual;
  const isAutoMode = activeTab === TABLE_MODE.auto;

  const getSearchedAppraisalsTableData = appraisals => {
    return appraisals.map(appraisal => {
      const isAssigned = assignedAppraisals.some(x => appraisal.id === x.id);
      const isAutoAssigned = autoAssignedAppraisals.some(x => appraisal.id === x.id);

      return AppraiserAppraisalsDataMapper.appraisalToTable(
        appraisal,
        isAssigned ? ACTION_TYPE.UNASSIGN : !isAutoAssigned ? ACTION_TYPE.ASSIGN : null
      );
    });
  };

  const getAssignedAppraisalsTableData = (appraisals, actionType = null) => {
    return appraisals.map(x => AppraiserAppraisalsDataMapper.appraisalToTable(x, actionType));
  };

  return (
    <>
      {isSearchMode && (
        <AppraiserAppraisalsTable
          {...otherProps}
          appraisals={getSearchedAppraisalsTableData(searchedAppraisals)}
          totalAppraisalsCount={searchedAppraisalsCount}
          handlePageChange={handlePageChange}
          currentPage={searchCurrentPage}
          pageSize={pageSize}
        />
      )}
      {isManualMode && (
        <AppraiserAppraisalsTable
          {...otherProps}
          appraisals={getAssignedAppraisalsTableData(assignedAppraisals, ACTION_TYPE.UNASSIGN)}
          totalAppraisalsCount={assignedAppraisals.length}
          pageSize={pageSize}
        />
      )}
      {isAutoMode && (
        <AppraiserAppraisalsTable
          {...otherProps}
          appraisals={getAssignedAppraisalsTableData(autoAssignedAppraisals)}
          totalAppraisalsCount={autoAssignedAppraisals.length}
          pageSize={pageSize}
        />
      )}
    </>
  );
};

const TABLE_MODE = {
  search: 'search',
  manual: 'manual',
  auto: 'auto'
};

const ACTION_TYPE = {
  ASSIGN: 'assign',
  UNASSIGN: 'unassign'
};

export default AppraiserAppraisalsTabTables;
